import React, {useState,useEffect, useLayoutEffect } from 'react'
import Hero from '../components/hero/Hero'
import Philosophy from '../components/philosophy/Philosophy'
import Quality from '../components/Quality/Quality,'
import Slide from '../components/slide/Slide'
import TextSlide from '../components/textSlide/TextSlide'
import PageLayout from './PageLayout'

export default function Home() {
  return ( 
      <PageLayout>
        <Hero/> 
        <Slide/>  
        <Philosophy/> 
        <Quality/> 
        <TextSlide/>
      </PageLayout>
  )
}
